import React, {useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import {Container, Grid,  Card, Button, Typography, Menu, MenuItem, IconButton , Box} from '@mui/material';
import { fetchClients } from '../../../actions/client';
import {fetchAllProperties} from '../../../actions/property'
import CommonTable from "../../common/table"
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {useSelector, useDispatch} from "react-redux"
import { styled } from '@mui/material/styles';
import SideNav from '../sidenav';
import {clientStyles} from "../../../styles/materialComponent"
import { getReport } from '../../../actions/report';
const report =[
    "Report Name",
    "Report No",
    "Client",
    "Property",
    "Action",
    "Status",    
]

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Reports = () => {
  const classes = clientStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const {allReports} = useSelector(({report})=>report)
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(()=>{
    dispatch(getReport())
  },[])

  return (   
    <Card
    style={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)", backgroundColor:"#FCFBFD"}}
    className={classes.clientContainer}
    >
      <div style={{padding:15, display: 'flex', justifyContent: 'space-between', padding:20}}>
      <Typography variant="h5">Reports</Typography>

      <Button variant="contained" style={{backgroundColor:"rgb(115 74 153)",  textTransform:"none"}} onClick={()=>navigate("/addReport", {state:{data: "/reports"}})}>
        Add Report 
        </Button>
        </div><hr />                     
      <CommonTable lable="reports" tableCols={report} tableRows={allReports}/>
  </Card>                        
  )
}

export default Reports